module.exports = __webpack_public_path__ + "img/16_72.3dcba662.png";